import { useMutation, useQueryClient } from '@tanstack/react-query';
import { showSnackbar } from '../../../api/snackbarSlice';
import { useDispatch } from 'react-redux';
import { apiClient } from '../../../utils/axios';
import { useState } from 'react';
import { AxiosError } from 'axios';
import { useTranslatedMessages } from '../../../hooks/useTranslatedMessages';
import { isString } from 'lodash';

export const mutateSupplier = async ({ payload, isEdit }) => {
  if (isEdit) {
    const { data } = await apiClient.put('/suppliers/' + payload.profile_id, payload);
    return data;
  } else {
    const { data } = await apiClient.post('/suppliers', payload);
    return data;
  }
};

export const useMutateSupplierHandler = ({ onSuccess }) => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();
  const [error, setError] = useState(null);
  const { snackbarMessages } = useTranslatedMessages();
  const supplierMessages = snackbarMessages.suppliers ?? {};

  const mutation = useMutation({
    mutationFn: mutateSupplier,
    onSuccess: (data, variables) => {
      dispatch(
        showSnackbar({
          message: supplierMessages.supplier_saved_success,
        }),
      );
      queryClient.invalidateQueries({ queryKey: ['suppliers'] });
      onSuccess && onSuccess(variables);
    },
    onError: (error) => {
      if (error instanceof AxiosError) {
        if (error.response?.status === 400) {
          setError(error.response.data.errors);
          return;
        }
        const apiMessage = error.response?.data?.error || error.response?.data?.message || error.message;
        dispatch(showSnackbar({ message: apiMessage, severity: 'error' }));
      } else {
        dispatch(
          showSnackbar({
            message: isString(error.message) ? error.message : JSON.stringify(error.message),
            severity: 'error',
          }),
        );
      }
    },
  });

  const onSubmit = async (data, isEdit) => {
    mutation.mutate({ payload: data, isEdit });
  };

  return {
    data: mutation.data,
    isError: mutation.isError,
    error: error,
    isPending: mutation.isPending,
    isSuccess: mutation.isSuccess,
    onSubmit: onSubmit,
  };
};
